import { Input } from './Input';
import { Button } from './Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Newsletter = _ref => {
  let {
    heading,
    subHeading = '',
    nameInputId,
    emailInputId
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "py-10",
    children: /*#__PURE__*/_jsx("div", {
      className: "container ml-auto mr-auto",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex w-full flex-col gap-16 overflow-hidden rounded-lg bg-accent p-8 md:rounded-xl lg:flex-row lg:items-center lg:p-16",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex-1",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "mb-3 text-2xl font-semibold md:mb-4 md:text-4xl lg:mb-6",
            children: heading
          }), subHeading && /*#__PURE__*/_jsx("p", {
            className: "text-muted-foreground lg:text-lg",
            children: subHeading
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "shrink-0",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex flex-col justify-center gap-2 sm:flex-row",
            children: [/*#__PURE__*/_jsx(Input, {
              id: nameInputId,
              name: nameInputId,
              className: "lg:min-w-68",
              placeholder: "Your name",
              required: true
            }), /*#__PURE__*/_jsx(Input, {
              id: emailInputId,
              name: emailInputId,
              className: "lg:min-w-68",
              placeholder: "Your email",
              type: "email",
              required: true
            }), /*#__PURE__*/_jsx(Button, {
              role: "submit",
              children: "Subscribe"
            })]
          }), /*#__PURE__*/_jsxs("p", {
            className: "mt-2 text-left text-xs text-muted-foreground",
            children: ["View our", ' ', /*#__PURE__*/_jsx("a", {
              href: "/privacy-policy",
              className: "underline hover:text-foreground",
              children: "privacy policy"
            }), "."]
          })]
        })]
      })
    })
  });
};

export default Newsletter;